module.exports = __webpack_public_path__ + "static/media/CB_engagement_22.6dd7b633.jpg";